import "../../App.css";
import Sidebar from "../../components/Sidebar";
import "../../styles/login.css";
import { withRouter } from "react-router-dom";
import React, { useState, useEffect } from "react";
import DualListBox from "react-dual-listbox";
import "react-dual-listbox/lib/react-dual-listbox.css";
import Parametros from "../Parametros";
import CurrentUser from "../CurrentUser";
import UserTab from "../UserTab";

function Perfiles(props) {
  const { history } = props;

  const [opcionesActions, setOpcionesActions] = useState([]);
  const [opcionesModules, setOpcionesModules] = useState([]);
  // const [modulos, setModulos] = useState([])
  const [perfilesStateUpdate, setperfilesStateUpdate] = useState([]);
  const [perfilesState, setperfilesState] = useState([]);

  // eslint-disable-next-line
  const [usuario, setUsuario] = useState(CurrentUser.user);
  // eslint-disable-next-line
  const [formularioUpdate, setformularioUpdate] = useState({});
  useEffect(() => {
    async function llamadaApi() {
      let responseActions = await fetch(
        Parametros.urlApi + "actions/?skip=0&limit=100",
        {
          headers: {
            Authorization: "Bearer " + usuario.key,
            Accept: "application/json",
            "Content-Type": "application/json",
            Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
          },
        }
      );
      if (responseActions.status === 200 || responseActions.status === 201) {
        let responseActionsJson = await responseActions.json();

        setOpcionesActions(responseActionsJson);
      } else if (responseActions.status === Parametros.loginTokenExcept) {
        alert(Parametros.loginTokenExceptMessage);
        history.push({
          pathname: "/",
        });
      }

      let responseModules = await fetch(
        Parametros.urlApi + "modules/?skip=0&limit=100",
        {
          headers: {
            Authorization: "Bearer " + usuario.key,
            Accept: "application/json",
            "Content-Type": "application/json",
            Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
          },
        }
      );

      if (responseModules.status === 200 || responseModules.status === 201) {
        let responseModulesJson = await responseModules.json();

        setOpcionesModules(responseModulesJson);
      } else if (responseModules.status === Parametros.loginTokenExcept) {
        alert(Parametros.loginTokenExceptMessage);
        history.push({
          pathname: "/",
        });
      }
      // let reponseModule = await fetch(Parametros.urlApi+"modules/")
      // let reponseModuleJson = await reponseModule.json()
      // setModulos(reponseModuleJson)

      let response = await fetch(Parametros.urlApi + "profiles", {
        headers: {
          Authorization: "Bearer " + usuario.key,
          Accept: "application/json",
          "Content-Type": "application/json",
          Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
        },
      });

      if (response.status === 200 || response.status === 201) {
        let responseJson = await response.json();

        let responseJsonUpdate = JSON.stringify(responseJson);
        let responseJsonstate = JSON.stringify(responseJson);
        setperfilesStateUpdate(JSON.parse(responseJsonUpdate));
        setperfilesState(JSON.parse(responseJsonstate));
      } else if (response.status === Parametros.loginTokenExcept) {
        alert(Parametros.loginTokenExceptMessage);
        history.push({
          pathname: "/",
        });
      }
    }

    llamadaApi();
  }, [history, usuario]);

  const [formularioState, setFormularioState] = useState({
    description: "",
  });

  let handleStageForm = (event) => {
    setFormularioState({
      ...formularioState,
      [event.target.name]: event.target.value,
    });
  };

  let crearperfiles = async (event) => {
    event.preventDefault();
    if (usuario.permisos.indexOf("Crear") > -1) {
      if (window.confirm("¿Esta seguro que deseas agregar este elemento?")) {
        // aqui deberia ir el delete segun response eliminar de la lista de react

        let response = await fetch(Parametros.post + "profiles", {
          method: "POST",
          body: JSON.stringify(formularioState),
          headers: {
            Authorization: "Bearer " + usuario.key,
            Accept: "application/json",
            "Content-Type": "application/json",
            Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
          },
        });
        let responseJson = await response.json();
        if (responseJson.id) {
          alert("Se creo el perfil correctamente");
          window.location.reload();
        } else {
          alert(responseJson.detail);
        }
      } else {
        // Do nothing!
        setperfilesState(JSON.parse(JSON.stringify(perfilesStateUpdate)));
      }
    } else {
      alert(usuario.crear);
    }
  };

  useEffect(() => {}, []);

  let selectOptionActions = async (selected, value) => {
    if (usuario.permisos.indexOf("Editar") > -1) {
      if (window.confirm("¿Esta seguro que deseas actualizar este elemento?")) {
        let url = Parametros.urlApi + "profiles/actions?perfil=" + selected;

        let urlList = "";
        value.map((id) => {
          return (urlList += "&lista_actions=" + id);
        });

        let response = await fetch(url + urlList, {
          method: "POST",
          headers: {
            Authorization: "Bearer " + usuario.key,
            Accept: "application/json",
            "Content-Type": "application/json",
            Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
          },
        });
        let responseJson = await response.json();

        let newArray = perfilesState;
        if (response.status === 200) {
          alert(
            "Actualizado correctamente, el usuario deberá volver a iniciar sesión para reflejar los cambios."
          );
          newArray.map((perfil) => {
            if (perfil.profile_id === selected) {
              return (perfil.actions = opcionesActions.filter(function (
                opcion
              ) {
                return value.includes(opcion.action_id);
              }));
            } else {
              return perfil.actions;
            }
          });
          setperfilesState(JSON.parse(JSON.stringify(newArray)));
          setperfilesStateUpdate(JSON.parse(JSON.stringify(newArray)));
        } else if (response.status === Parametros.loginTokenExcept) {
          alert(Parametros.loginTokenExceptMessage);
          history.push({
            pathname: "/",
          });
        } else {
          alert("error al actualizar");
        }
      }
    } else {
      alert(usuario.editar);
    }
  };
  let selectOptionModules = async (selected, value) => {
    if (usuario.permisos.indexOf("Editar") > -1) {
      if (window.confirm("¿Esta seguro que deseas actualizar este elemento?")) {
        let url = Parametros.urlApi + "profiles/modules?perfil=" + selected;

        let urlList = "";
        value.map((id) => {
          return (urlList += "&lista_modulos=" + id);
        });

        let response = await fetch(url + urlList, {
          method: "POST",
          headers: {
            Authorization: "Bearer " + usuario.key,
            Accept: "application/json",
            "Content-Type": "application/json",
            Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
          },
        });
        if (response.status === 200) {
          alert(
            "Actualizado correctamente, el usuario deberá volver a iniciar sesión para reflejar los cambios."
          );
          let responseJson = await response.json();

          let newArray = perfilesState;

          newArray.map((perfil) => {
            if (perfil.profile_id === selected) {
              perfil.modules = opcionesModules.filter(function (opcion) {
                return value.includes(opcion.module_id);
              });
              return perfil.modules;
            } else {
              return perfil.modules;
            }
          });

          setperfilesState(JSON.parse(JSON.stringify(newArray)));
          setperfilesStateUpdate(JSON.parse(JSON.stringify(newArray)));
        } else if (response.status === Parametros.loginTokenExcept) {
          alert(Parametros.loginTokenExceptMessage);
          history.push({
            pathname: "/",
          });
        } else {
          alert("error al actualizar");
        }
      }
    } else {
      alert(usuario.editar);
    }
  };

  function tabControl(evt, tabseleccion, id) {
    var i, tabcontent, tablinks;
    tabcontent = document.getElementsByClassName("tabcontent" + id);
    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = "none";
    }
    tablinks = document.getElementsByClassName("tablinks" + id);
    for (i = 0; i < tablinks.length; i++) {
      tablinks[i].className = "tablinks" + id;
    }

    document.getElementById(tabseleccion + id).style.display = "block";
    evt.currentTarget.className += " active";
  }

  return (
    <div className="App">
      <Sidebar tipo="2"></Sidebar>
      <br />
      <UserTab nombre={"Perfiles"}></UserTab>
      <div className="container">
        <form id="formularioBusqueda" onSubmit={crearperfiles}>
          <div className="col-md-4">
            <h5>Nombre Perfil</h5>
            <input
              onChange={handleStageForm}
              name="description"
              required
              className="form-control"
            ></input>
          </div>
          <div className="col-md-4">
            <br />
            <button
              type="submit"
              value="Submit"
              style={{ margin: "14px 0px" }}
              id="btnBuscar"
              className="form-control button brEdit btn-primary"
            >
              Agregar nuevo perfil
            </button>
          </div>
        </form>

        {usuario.permisos.indexOf("Ver") > -1 ? (
          <>
            {perfilesState.map((item, index) => {
              return (
                <div
                  key={index}
                  className="perfilCard"
                >
                  <div className="perfilCardHeader">
                    <h4>{item.description}</h4>
                  </div>
                  <div className="tab">
                    <button
                      className={"active tablinks" + item.profile_id}
                      onClick={(event) =>
                        tabControl(event, "Acciones", item.profile_id)
                      }
                    >
                      Acciones
                    </button>
                    <button
                      className={"tablinks" + item.profile_id}
                      onClick={(event) =>
                        tabControl(event, "Modulos", item.profile_id)
                      }
                    >
                      Modulos
                    </button>
                  </div>

                  <div
                    id={"Acciones" + item.profile_id}
                    className={"tabcontent" + item.profile_id}
                  >
                    <div className="col-md-6">Posibles</div>
                    <div className="col-md-6">Actuales</div>
                    <div className="col-md-12">
                      <DualListBox
                        key={item.profile_id}
                        icons={{
                          moveLeft: (
                            <span className="glyphicon glyphicon-chevron-left" />
                          ),
                          moveAllLeft: [
                            <span
                              key={0}
                              className="glyphicon glyphicon-chevron-left"
                            />,
                            <span
                              key={1}
                              className="glyphicon glyphicon-chevron-left"
                            />,
                          ],
                          moveRight: (
                            <span className="glyphicon glyphicon-chevron-right" />
                          ),
                          moveAllRight: [
                            <span
                              key={0}
                              className="glyphicon glyphicon-chevron-right"
                            />,
                            <span
                              key={1}
                              className="glyphicon glyphicon-chevron-right"
                            />,
                          ],
                          moveDown: <span className="fa fa-chevron-down" />,
                          moveUp: <span className="fa fa-chevron-up" />,
                          moveTop: <span className="fa fa-double-angle-up" />,
                          moveBottom: (
                            <span className="fa fa-double-angle-down" />
                          ),
                        }}
                        options={opcionesActions.map((accion) => {
                          let itemNew = {
                            label: accion.decription,
                            value: accion.action_id,
                          };

                          return itemNew;
                        })}
                        selected={item.actions.map((action) => {
                          return action.action_id;
                        })}
                        onChange={(value) => {
                          selectOptionActions(item.profile_id, value);
                        }}
                      />
                    </div>
                  </div>

                  <div
                    id={"Modulos" + item.profile_id}
                    style={{ display: "none" }}
                    className={"tabcontent" + item.profile_id}
                  >
                    <div className="col-md-6">Posibles</div>
                    <div className="col-md-6">Actuales</div>
                    <div className="col-md-12">
                      <DualListBox
                        key={item.profile_id}
                        icons={{
                          moveLeft: (
                            <span className="glyphicon glyphicon-chevron-left" />
                          ),
                          moveAllLeft: [
                            <span
                              key={0}
                              className="glyphicon glyphicon-chevron-left"
                            />,
                            <span
                              key={1}
                              className="glyphicon glyphicon-chevron-left"
                            />,
                          ],
                          moveRight: (
                            <span className="glyphicon glyphicon-chevron-right" />
                          ),
                          moveAllRight: [
                            <span
                              key={0}
                              className="glyphicon glyphicon-chevron-right"
                            />,
                            <span
                              key={1}
                              className="glyphicon glyphicon-chevron-right"
                            />,
                          ],
                          moveDown: <span className="fa fa-chevron-down" />,
                          moveUp: <span className="fa fa-chevron-up" />,
                          moveTop: <span className="fa fa-double-angle-up" />,
                          moveBottom: (
                            <span className="fa fa-double-angle-down" />
                          ),
                        }}
                        options={opcionesModules.map((modulo) => {
                          let itemNew = {
                            label: modulo.module + " " + modulo.submodule,
                            value: modulo.module_id,
                          };
                          return itemNew;
                        })}
                        selected={item.modules.map((module) => {
                          return module.module_id;
                        })}
                        onChange={(value) => {
                          selectOptionModules(item.profile_id, value);
                        }}
                      />
                    </div>
                  </div>
                </div>
              );
            })}
          </>
        ) : (
          <div className="col-md-12">
            <h1>{usuario.ver}</h1>
          </div>
        )}
      </div>
    </div>
  );
}

export default withRouter(Perfiles);
